import { render, staticRenderFns } from "./SetParamPage.vue?vue&type=template&id=0b86ebfe&scoped=true"
import script from "./SetParamPage.vue?vue&type=script&lang=js"
export * from "./SetParamPage.vue?vue&type=script&lang=js"
import style0 from "./SetParamPage.vue?vue&type=style&index=0&id=0b86ebfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86ebfe",
  null
  
)

export default component.exports